// src/pages/AffiliatesPage.js
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Box,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../firebase";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const AffiliatesPage = () => {
  const [affiliates, setAffiliates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    uid: "",
    name: "",
    email: "",
    password: "",
    phone: "",
    photoURL: "",
    commissionRate: 2,
    bankName: "",
    accountName: "",
    accountNumber: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAffiliates = async () => {
      try {
        const affiliatesSnapshot = await getDocs(
          query(
            collection(firestore, "users"),
            where("role", "==", "affiliate")
          )
        );
        const affiliatesList = affiliatesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAffiliates(affiliatesList);
      } catch (error) {
        console.error("Error fetching affiliates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAffiliates();
  }, []);

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => {
    setOpen(false);
    resetForm();
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCreateAffiliate = async () => {
    console.log("form: ", form);
    if (!form.name || !form.email || !form.password) {
      alert("Name, Email, and Password are required.");
      return;
    }

    try {
      const createAffiliateWithAuth = httpsCallable(
        functions,
        "createAffiliateWithAuth"
      );
      await createAffiliateWithAuth({
        name: form.name,
        email: form.email,
        password: form.password,
        phone: form.phone,
        commissionRate: parseFloat(form.commissionRate),
        bankDetails: {
          bankName: form.bankName,
          accountName: form.accountName,
          accountNumber: form.accountNumber,
        },
      });

      handleCloseDialog();
      window.location.reload();
    } catch (error) {
      console.error("Error creating affiliate with auth:", error);
      alert("Error creating affiliate: " + error.message);
    }
  };

  const resetForm = () => {
    setForm({
      uid: "",
      name: "",
      email: "",
      phone: "",
      photoURL: "",
      password: "",
      commissionRate: 2,
      bankName: "",
      accountName: "",
      accountNumber: "",
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header />
        <Container sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h4">Affiliates Monitoring</Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={handleOpenDialog}
            >
              Add Affiliate
            </Button>
          </Box>

          {loading ? (
            <CircularProgress sx={{ display: "block", margin: "20px auto" }} />
          ) : affiliates.length === 0 ? (
            <Typography align="center">No affiliates found.</Typography>
          ) : (
            <Grid container spacing={3}>
              {affiliates.map((affiliate) => (
                <Grid item xs={12} sm={6} md={4} key={affiliate.id}>
                  <Card sx={{ p: 2 }}>
                    <CardContent>
                      <Typography variant="h6">
                        {affiliate.name || "Unnamed Affiliate"}
                      </Typography>
                      <Typography>
                        Shops Affiliated:{" "}
                        {affiliate.assignedShops
                          ? affiliate.assignedShops.length
                          : 0}
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{ mt: 2 }}
                        onClick={() => navigate(`/affiliate/${affiliate.id}`)}
                      >
                        View Details
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          <Dialog
            open={open}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Create New Affiliate</DialogTitle>
            <DialogContent>
              <TextField
                label="Name"
                name="name"
                value={form.name}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
              <TextField
                label="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
              <TextField
                label="Password"
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
              <TextField
                label="Phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
              <TextField
                label="Commission Rate (%)"
                name="commissionRate"
                value={form.commissionRate}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
              <Typography variant="h6" sx={{ mt: 3 }}>
                Bank Details
              </Typography>
              <TextField
                label="Bank Name"
                name="bankName"
                value={form.bankName}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 1 }}
              />
              <TextField
                label="Account Name"
                name="accountName"
                value={form.accountName}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
              <TextField
                label="Account Number"
                name="accountNumber"
                value={form.accountNumber}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Cancel</Button>
              <Button variant="contained" onClick={handleCreateAffiliate}>
                Create
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
        <Footer />
      </Box>
    </>
  );
};

export default AffiliatesPage;
